import { debounce } from "lodash";
import { useLayoutEffect, useState } from "react";

import { breakpoints } from "@/styles/screens";

/**
 * Below `desktop` (1024px, this app's actual "desktop" design token) - not to
 * be confused with `useIsMobile` (<768px, "tablet"), which most of the app
 * still uses for its own mobile/desktop split. Currently only PortalPageLayout
 * needs this one, to keep the Sidebar from showing at tablet widths.
 */
export const useIsBelowDesktopBreakpoint = (): boolean => {
  const [isBelowDesktop, setIsBelowDesktop] = useState(
    window.innerWidth < breakpoints.desktop,
  );

  useLayoutEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const updateSize = (): void => {
      setIsBelowDesktop(window.innerWidth < breakpoints.desktop);
    };
    const debouncedUpdateSize = debounce(updateSize, 250);
    window.addEventListener("resize", debouncedUpdateSize);

    return (): void => {
      window.removeEventListener("resize", debouncedUpdateSize);
      debouncedUpdateSize.cancel();
    };
  }, []);

  return isBelowDesktop;
};
